import VehicleDetailsPage from "./VehicleDetailsPage";

export default VehicleDetailsPage;
